import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { academylist } from "../../../services/admin";
import { createcompbook, detailcompbook } from "../../../services/common";
import { toast } from "react-toastify";
import moment from "moment";

export default function Addcomplaints() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [cname, setCName] = useState("");
  const [cdate, setCDate] = useState("");
  const [cphone, setCPhone] = useState("");
  const [cpriority, setCPriority] = useState("");
  const [creason, setCReason] = useState("");
  const [cfile, setCFile] = useState("");
  const [curl, setCUrl] = useState("");

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const location = useLocation();
  const [urllink, setUrllink] = useState("");
  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrllink(path);

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });
    if (path === "complaintdetail") {
      detailcompbook(id).then((res) => {
        if (res.status === true) {
          if (res.data.details !== null) {
            setCName(res.data.details.complaint_name);
            setCPhone(res.data.details.phone);
            setCPriority(res.data.details.priority);
            setCReason(res.data.details.complaint_reason);
            if (res.data.details.complaint_file !== null) {
              setCUrl(res.data.path+res.data.details.complaint_file);
            }
            setCDate(moment(res.data.details.complaint_date).format("YYYY-MM-DD"));
            academylist().then((res1) => {
              if (res1.status === true) {
                let arr = [];
                if (res1.data.details.length > 0) {
                  for (let i = 0; i < res1.data.details.length; i++) {
                    if (
                      res1.data.details[i].id == res.data.details.academy_id
                    ) {
                      arr.push({
                        value: res1.data.details[i].id,
                        label:
                          res1.data.details[i].name +
                          " - " +
                          res1.data.details[i].code,
                      });
                    }
                  }
                  setAcaID(arr[0]);
                }
              }
            });
          }
        }
      });
    } else {
     
      if (localStorage.getItem("ADate") !== '') {
            setCDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
          } else {
            setCDate(moment(new Date()).format("YYYY-MM-DD"));
          }
          if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
              if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                  for (let i = 0; i < res.data.details.length; i++) {
                    if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                      arr.push({
                        value: res.data.details[i].id,
                        label:
                          res.data.details[i].name + " - " + res.data.details[i].code,
                      });
                    }
                    if (arr.length > 0) {
                      setAcaID(arr[0]);
                     
                    }
                  }
                 
                }
              }
            });
          }
    }
  }, [location.pathname]);

  function handlePhone(e) {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setCPhone(e.target.value);
    }
  }

  const [photoerror, setPhotoError] = useState("");
  function photofile(event) {
    setPhotoError("");
    setCFile("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png|pdf)$/i)) {
        setCUrl(URL.createObjectURL(event.target.files[0]));
        setCFile(event.target.files[0]);
      } else {
        setPhotoError("Attachment should be jpg, jpeg, or png or pdf format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setCFile("Attachment size should be less than 5MB");
      }
    }
  }
  const [cerror, setCError] = useState(false);
  function submitcomp(e) {
    e.preventDefault();
    setCError(true);
    if (
      cname !== "" &&
      cdate !== "" &&
      cphone !== "" &&
      cpriority !== "" &&
      creason !== ""
    ) {
      setLoading(true);
      const temp = new FormData();
      temp.append("complaint_name", cname);
      temp.append("phone", cphone);
      temp.append("priority", cpriority);
      temp.append("complaint_reason", creason);
      temp.append("complaint_file", cfile);
      temp.append("complaint_date", cdate);
      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        temp.append("academy_id", acaid.value);
      }
      if (urllink === "complaintdetail") {
        temp.append("id", id);
      }
      createcompbook(temp).then((res) => {
        if (res.status === true) {
          setLoading(false);
          setCError(false);
          navigate("/complaints/allcomplaints");
          toast.success(res.message);
        } else {
          setLoading(false);
          setCError(false);
          toast.error(res.message);
        }
      });
    }
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
    } else {
      setAcaID("");
    }
  }
  const [loading, setLoading] = useState(false);

  function errorhandle(ev) {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  }
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">
          {urllink === "addcomplaint" ? "Add Complaint" : "Complaint Details"}
        </h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Complaint Book</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "addcomplaint" ? "Add Complaint" : "Complaint Details"}
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-xl-12 col-lg-12">
                    <div className="row">
                      {localStorage.getItem("Role") === "1" && (
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Select Academy{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="Select Academy"
                              value={acaid}
                              options={aclist}
                              onChange={handleAcademy}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                            {cerror && acaid === "" && (
                              <span className="text-danger">
                                Please Select Academy
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Name<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                            onChange={(e) => setCName(e.target.value)}
                            value={cname}
                          />
                          {cerror && cname === "" && (
                            <span className="text-danger">
                              Please Enter Name
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Date<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            onChange={(e) => setCDate(e.target.value)}
                            value={cdate}
                          />
                          {cerror && cdate === "" && (
                            <span className="text-danger">
                              Please Select Date
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Phone Number"
                            onChange={handlePhone}
                            value={cphone}
                            maxLength="10"
                          />
                          {cerror && cphone === "" && (
                            <span className="text-danger">
                              Please Enter Phone Number
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Complaint Priority{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select form-control wide"
                            onChange={(e) => setCPriority(e.target.value)}
                            value={cpriority}
                          >
                            <option value="" disabled>
                              Select Complaint Priority
                            </option>
                            <option value="High">High</option>
                            <option value="Medium">Medium</option>
                            <option value="Low">Low</option>
                          </select>
                          {cerror && cpriority === "" && (
                            <span className="text-danger">
                              Please Select Priority
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Complaint<span className="text-danger"> *</span>
                          </label>
                          <textarea
                            className="form-control"
                            rows={4}
                            placeholder="Enter your Complaint"
                            onChange={(e) => setCReason(e.target.value)}
                            value={creason}
                          />
                          {cerror && creason === "" && (
                            <span className="text-danger">
                              Please Enter Complaint
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Attachment
                            <span className="text-danger text-danger-small">
                              {" "}
                              (Files Format: jpg, jpeg, png or pdf )
                            </span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={photofile}
                          />
                          {photoerror !== "" && (
                            <span className="text-danger">{photoerror}</span>
                          )}
                        </div>
                      </div>
                      {curl !== "" && (
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            {curl.split(".").pop() === "pdf" && (
                              <a href={curl} target="_blank">
                                <img
                                  src={require("../../../assets/images/pdf.png")}
                                  width="150px"
                                  height="150px"
                                />
                              </a>
                            )}
                            {curl.split(".").pop() !== "pdf" && (
                              <a href={curl} target="_blank">
                                <img src={curl} width="150px" height="150px" onError={errorhandle} />
                              </a>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="res-right mt-4 mb-4  me-4">
              <button className="btn btn-success me-2" onClick={submitcomp}>
                Submit
              </button>
              {urllink !== "addcomplaint" && (
                <button
                  className="btn btn-secondary"
                  onClick={() => navigate("/complaints/addcomplaint")}
                >
                  Back
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
